import { Controller } from '@hotwired/stimulus'
import { DeliveryAddress } from "../utils/delivery_address"
import { AddressAPI } from "../utils/address_api"
import { PopoverHandler } from "../utils/popover_handler"
export default class extends Controller {
  static targets = ["quantity",
                    "decreaseButton",
                    "variantID",
                    "selectedVariant",
                    "mainImage",
                    "popoverWrapper",
                    "popoverOutofStockWrapper",
                    "price",
                    "increaseQuantity",
                    "presentationUnit",
                    "form",
                    "submitBtn"]

  connect () {
    let addedQuantity = 0;

    this.formTarget.addEventListener("ajax:before", () => {
      this.submitBtnTarget.disabled = true
      this.submitBtnTarget.innerText = "Adding..."

      addedQuantity = this.quantityTarget.value;
    })

    this.formTarget.addEventListener("ajax:success", (event) => {
      const [ data, _status, _xhr ] = event.detail
      this.submitBtnTarget.innerText = "Add to Cart"
      this.updateShoppingBagCounter(data)

      gtag('event', 'add_to_cart')
      Turbolinks.visit("/store/cart")
    })
  }

  disconnect () {
    this.submitBtnTarget.disabled = false
    this.quantityTarget.value = 1
    this.decreaseButtonTarget.disabled = true
  }

  changeMainImage(e) {
    e.preventDefault()
    const mainImageElement = this.mainImageTarget.querySelector("img")

    mainImageElement.setAttribute("src", e.target.parentElement.href)
  }

  variantSelected(e) {
    e.preventDefault()
    const variantID = e.target.dataset.variantId
    const thcPercentage = document.querySelector("[data-property-thc-percentage]")
    const cbdPercentage = document.querySelector("[data-property-cbd-percentage]")
    const totalAvailable = parseInt(e.target.dataset.totalOnHand) - parseInt(e.target.dataset.totalInCart)


    this.variantIDTarget.value = variantID
    this.variantIDTarget.setAttribute("data-total-on-hand", e.target.dataset.totalOnHand)
    this.variantIDTarget.setAttribute("data-total-in-cart", e.target.dataset.totalInCart)
    this.priceTarget.innerText = e.target.dataset.variantPrice
    this.presentationUnitTarget.innerText = e.target.dataset.variantPresentationUnit

    if(thcPercentage) {thcPercentage.innerText = `THC: ${e.target.dataset.thcPercentage}` }
    if(cbdPercentage) {cbdPercentage.innerText = `CBD: ${e.target.dataset.cbdPercentage}` }

    if(totalAvailable == 0) {
      this.increaseQuantityTarget.setAttribute("disabled", false)
      this.submitBtnTarget.setAttribute("disabled", false)

    } else {
      this.increaseQuantityTarget.removeAttribute("disabled", false)
      this.submitBtnTarget.removeAttribute("disabled", false)
    }
  }

  updateQuantity(e) {
    let quantity = parseInt(this.quantityTarget.value)
    let totalAvailable = parseInt(this.variantIDTarget.dataset.totalOnHand) - parseInt(this.variantIDTarget.dataset.totalInCart)

    if(totalAvailable == 0) {
      PopoverHandler().showPopover(this.popoverOutofStockWrapperTarget)
      e.target.setAttribute("disabled", "disabled")
      this.quantityTarget.value = 1
      return;
    }

    if(e.target.innerText == "+") {
      quantity += 1
    } else {
      quantity -= 1
      this.increaseQuantityTarget.removeAttribute("disabled", false)
    }


    this.decreaseButtonTarget.toggleAttribute("disabled", quantity <= 1)

    if(quantity < 1) { return }
    this.quantityTarget.value = quantity

    if(quantity == totalAvailable) {
      e.target.setAttribute("disabled", "disabled")
      PopoverHandler().showPopover(this.popoverOutofStockWrapperTarget)
    }
  }

  showAddressPopover(e) {
    DeliveryAddress().showPopover();
  }

  invalidAddressPopover() {
    let inExclusionArea = this.popoverWrapperTarget.dataset.inExclusionArea == "true"
    if(this.popoverWrapperTarget.dataset.validForDeliver == "false") {
      AddressAPI().showInvalidAddressMsg(inExclusionArea, this.popoverWrapperTarget)
     }
  }

  outOfStockPopover() {
    let totalAvailable = parseInt(this.variantIDTarget.dataset.totalOnHand) - parseInt(this.variantIDTarget.dataset.totalInCart)

    if(totalAvailable == 0) { PopoverHandler().showPopover(this.popoverOutofStockWrapperTarget) }
  }

  updateShoppingBagCounter (data) {
    let cartBag = document.querySelector(".shopping-bag-item-count")
    cartBag.innerText = data.order.item_count
  }
}
